import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import httpClient from "@/config/axios";

export type NoticeListItem = {
  id: number;
  title: string;
  author_name: string;
  is_pinned: boolean;
  created_at: string;
  updated_at: string;
};

export type NoticeListResponse = {
  total: number;
  items: NoticeListItem[];
};

/** 더미 데이터 - 개발/테스트용 */
const mockNoticeList: NoticeListResponse = {
  total: 5,
  items: [
    {
      id: 1,
      title: "[공지] 시스템 점검 안내",
      author_name: "관리자",
      is_pinned: true,
      created_at: "2026-03-15T10:00:00",
      updated_at: "2026-03-15T10:00:00",
    },
    {
      id: 2,
      title: "신규 기능 업데이트 안내",
      author_name: "운영팀",
      is_pinned: false,
      created_at: "2026-03-14T14:30:00",
      updated_at: "2026-03-14T14:30:00",
    },
    {
      id: 3,
      title: "근무표 작성 가이드",
      author_name: "관리자",
      is_pinned: false,
      created_at: "2026-03-13T09:15:00",
      updated_at: "2026-03-13T09:15:00",
    },
    {
      id: 4,
      title: "이벤트 안내 - 신규 가입자 혜택",
      author_name: "마케팅팀",
      is_pinned: false,
      created_at: "2026-03-12T16:45:00",
      updated_at: "2026-03-12T16:45:00",
    },
    {
      id: 5,
      title: "문의사항 접수 방법 안내",
      author_name: "고객지원팀",
      is_pinned: false,
      created_at: "2026-03-11T11:20:00",
      updated_at: "2026-03-11T11:20:00",
    },
  ],
};

/**
 * 공지사항 목록을 가져오는 커스텀 훅
 * @param page 페이지 번호 (기본 1)
 * @param pagesize 페이지 크기 (기본 10)
 * @returns useQuery 결과
 */
export function useNoticeList(page: number = 1, pagesize: number = 10) {
  return useQuery({
    queryKey: QUERY_KEYS.notice.list(page, pagesize),
    queryFn: async () => {
      // 더미 데이터 사용 (개발/테스트용)
      //   return mockNoticeList;

      // 실제 API 호출 (주석 처리)
      return await httpClient.get<NoticeListResponse>("/contact/notice/list", {
        params: { page, pagesize },
      });
    },
  });
}
